import jQuery from "jquery";

jQuery(function ($) {
  let date_start_angak = $('#input_1_23_3').val() +'-'+ $('#input_1_23_1').val().padStart(2, "0") +'-'+ $('#input_1_23_2').val().padStart(2, "0");
  let date_start_activity = $('#input_1_40_3').val() +'-'+ $('#input_1_40_1').val().padStart(2, "0") +'-'+ $('#input_1_40_2').val().padStart(2, "0");
  show_the_good_price(date_start_angak, date_start_activity);
  
  //PDF download (espace juridique)
  $(document).on("gform_confirmation_loaded", function (event, formId) {
    //simulate download waiting time
    setTimeout(function () {
      const pdfURL = $("#pdf_url_confirmation");
      if (pdfURL) {
        pdfURL.get(0).click();
      }
    }, 800);
  });

  // Update user's informations
  if ($("form .gform_body").length > 0) {
    $(".name_identity .name_first input").val(user.first_name);
    $(".name_identity .name_last input").val(user.last_name);
    $(".number_adh input").val(user.number_adh);
    $(".cotisation_adh input").val(user.cotisation_adh);
    
    // Datepicker evolute - start
    $("input.datepicker").on('keypress', function(e){
      // Do not write / and add 0 when single number
      if(e.keyCode == 47){
        if($(this).val().length === 1){
          $(this).val('0'+$(this).val());
        }
        if($(this).val().length === 4){
          $(this).val($(this).val().replace('/', '/0'));
        }
        e.preventDefault();
        return false;
      }
    });
    $("input.datepicker").on('keyup', function(e){
      // If 2 caract, add /
      if($(this).val().length === 2){
        $(this).val($(this).val()+'/');
      }
      // If 5 caract, add /
      if($(this).val().length === 5){
        $(this).val($(this).val()+'/');
      }

    });
    // end - Datepicker evolute
  }

  $(".cotisation_adh input").on('change', function(){
    $(".cotisation_adh input").val(user.cotisation_adh);
  });

  $(".address_announce .address_city input").on("keypress", function () {
    // if($(this).val().length > 1){
    // console.log('keypress');
    // wp.ajax({
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         'Cache-Control': 'no-cache',
    //     },
    //     body: new URLSearchParams(data),
    // })
    // .then(response => response.json())
    // .then(body => {
    //     console.log(body);
    //     // En cas d'erreur
    //     if (!body.success) {
    //         alert(response.data);
    //         return;
    //     }
    //     // Et en cas de réussite
    //     $(this).hide(); // Cacher le formulaire
    //     $('.comments').html(body.data); // Et afficher le HTML
    // });
    // }
  });
  $(".address_announce .address_state input").on("keypress", function () {
    // if($(this).val().length > 1){
    //     console.log('keypress aussi');
    // }
  });


  // Form adhesion
  if ($("form .gform_body .type_adhesion").length > 0) {
    var url = window.location.href;
    var pathname = window.location.pathname;
    var hash = url.split('#').pop();
    
    if(pathname == '/adhesion/' && hash == 'gf_1'){
      $('.type_adhesion input[name="input_50"][value="Adhésion"]').prop("checked", true);
    }
  }


    $('form .gform_body .date_angak input').on('change', () => {      
      let date_start_angak = $('#input_1_23_3').val() +'-'+ $('#input_1_23_1').val().padStart(2, "0") +'-'+ $('#input_1_23_2').val().padStart(2, "0");
      let date_start_activity = $('#input_1_40_3').val() +'-'+ $('#input_1_40_1').val().padStart(2, "0") +'-'+ $('#input_1_40_2').val().padStart(2, "0");
      if(date_start_angak.length == 10 && date_start_activity.length == 10){
        show_the_good_price(date_start_angak, date_start_activity, 1)
      }
    });

  function show_the_good_price(date_start_angak, date_start_activity, change_year = 0){
    console.log(date_start_activity, date_start_angak);
    let diff = monthDiff(date_start_activity, date_start_angak);
    console.log(diff);
    if(change_year === 1){
      $('input[name="input_53"]').each(function(e){
        $(this).prop("checked", false);
      });
    } else {

    }

    if(diff > 12){
      $('input[name="input_53"]:first').prop("disabled", true);
      $('input[name="input_53"]:first').parent().hide();
      $('input[name="input_53"]:last').prop("disabled", false);
      // $('input[name="input_53"]:last').prop("checked", true);
      $('input[name="input_53"]:last').parent().show();
      $('input[name="input_28"]').val('');
    } else {
      $('input[name="input_53"]:first').prop("disabled", false);
      // $('input[name="input_53"]:first').prop("checked", true);
      $('input[name="input_53"]:first').parent().show();
      $('input[name="input_53"]:last').prop("disabled", true);
      $('input[name="input_53"]:last').parent().hide();
      $('input[name="input_28"]').val('');
    }
  }

  function monthDiff(dateFrom, dateTo) {
    let result = (Date.parse(dateTo) - Date.parse(dateFrom)) / 2629743000; // Count number of month
    return result;
  }
});
